import React, { useEffect, useState } from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import s1 from "../../../Assets/images/sg1.png";
import s2 from "../../../Assets/images/sg2.png";
import { Accordion, Button } from "react-bootstrap";
import {
  CHATTER_EVENT,
  CHATTER_EVENT_ATTENDANCE,
  CHATTER_LESSON_PLANS,
  MANAGE_GROUP,
  CLASSROOM_SERVICES,
  MULTIDISCIPLINARY_SERVICES,
  MY_FAVOURITE_GOAL,
  MY_RESOURCES,
  SCHOOL_DISCHARGES,
  SHARED_LESSION_PLAN,
  ABOUT_US,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  VIDEOS,
  POLICY_AND_PROCEDURES,
  MANAGE_STAFF,
  MANAGE_TEAM,
  MANAGE_PARENT,
  MANAGE_APPOINTMENT_LIST,
  STAFF_TASKS_TEMPLATES,
  COMPONENT_TEMPLATES,
  CLASSROOM_REPORTS,
  WORKSHOPS,
  RECOMMENDATIONS_TEMPLATES,
  STRATEGIES_TEMPLATES,
  NOTES_TABLE,
  TASK_PLAN_TEMPLATES
} from "config/paths";
import { useLogoutMutation } from "store/services/sso";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import useSocket from "utils/socket/socket";
import { store } from "store/store";
import { useSelector } from "react-redux";

const Sidebar = ({ sidebar, setSidebar }) => {
  const navigate = useNavigate();
  const isVeteran = store.getState()?.auth?.user?.role_type === "veteran";
  const profile = useSelector((state) => state?.auth?.user)
  const assignedCategory = profile?.assigned_client_category
    ? profile.assigned_client_category.split(',').map(item => item.trim())
    : [];

  console.log('assignedCategory', assignedCategory)

  const location = useLocation();
  const pageActive = location.pathname;
  const socket = useSocket();

  const [onlyMdt, setOnlyMdt] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logout, { isLoading: logoutLoading }] = useLogoutMutation();

  console.log('onlyMdt', onlyMdt)
  const handleLogout = async () => {
    try {

      setShowLogoutModal(false)
      await logout();
      socket.disconnect();
    } catch (err) {
      console.log("Error logging user out", err);
    }
  };

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  const CustomBox = ({ children }) => {
    return (
      <div className="d-flex opacity-100 gap-2 px-3 align-items-center">
        {children}
      </div>
    );
  };

  const routeMap = {
    school: "/client/school",
    home_education: "/client/home-education",
    private: "/client/private",
    chatter: "/client/chatter",
    mdt: "/multidisciplinary-services",
  };

  const priority = [
    "school",
    "home_education",
    "private",
    "chatter",
    "mdt",
  ];

  // Set the flag whenever the user is MDT-only
  useEffect(() => {
    if (!assignedCategory?.length) return;

    setOnlyMdt(
      assignedCategory.length === 1 &&
      assignedCategory.includes("mdt")
    );
  }, [assignedCategory]);

  useEffect(() => {
    if (location.pathname !== "/client/school") return;
    if (!assignedCategory?.length) return;

    // Stay on school if the user has access.
    if (assignedCategory.includes("school")) return;

    const firstAllowed = priority.find(category =>
      assignedCategory.includes(category)
    );

    if (!firstAllowed) return;

    if (firstAllowed === "mdt") {
      setOnlyMdt(true);
    }

    navigate(routeMap[firstAllowed], { replace: true });
  }, [assignedCategory, location.pathname, navigate]);

  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active
        } sidebar sidebar-icon position-fixed shadow-lg  `}
    >
      <ConfirmationPop
        confirmation={showLogoutModal}
        setConfirmation={setShowLogoutModal}
        type={"logout"}
        confirmHandler={handleLogout}
      />

      {logoutLoading && <LoadingOverlay />}
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0, zIndex: 99 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="black"
          />
        </svg>
      </Button>
      <div
        className={`${styles.top} top text-center px-3  position-relative`}
      >
        <img
          src={s2}
          style={{ left: 0, bottom: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <img
          src={s1}
          style={{ right: 0, top: 0 }}
          alt=""
          className="img-fluid position-absolute"
        />
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion style={{ height: "calc(100vh - 70px)" }}
        className={`${styles.linkWrpper} linkWrpper  px-2.5 bg-white overflow-x-hidden overflow-y-auto`}

        defaultActiveKey={["0", "1"]}
        alwaysOpen
      >
        <div className="">
          <ul className="list-unstyled ps-0 mb-0">
            <li className="">
              {
                !onlyMdt &&
                <Accordion.Item
                  className={`${styles.accordionWrp} border-0 bg-transparent`}
                  eventKey="0"
                >
                  <Accordion.Header
                    className={`${styles.accordionBtn} ${pageActive.includes("client") && styles.active
                      } d-flex align-items-center gap-10 shadow-sm text-capitalize`}
                  >

                    My Clients
                  </Accordion.Header>
                  <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                    <ul className="list-unstyled  mb-0">
                      {
                        assignedCategory?.includes("school") &&
                        <li className="">
                          <NavLink
                            to="/client/school"
                            className={`${styles.subLinks} ${pageActive.includes("/client/school") && styles.active
                              }  d-flex`}
                          >
                            <CustomBox children={'School Clients'} />

                          </NavLink>
                        </li>
                      }
                      {
                        assignedCategory?.includes("home_education") &&
                        <li className="">
                          <NavLink
                            to="/client/home-education"
                            className={`${styles.subLinks} ${(pageActive.includes("/client/home-education") || pageActive.includes("/client/home_education")) &&
                              styles.active
                              }  d-flex`}
                          >
                            <CustomBox children={'Home Education'} />

                          </NavLink>
                        </li>
                      }
                      {
                        assignedCategory?.includes("chatter") &&
                        <li className="p-10">
                          <NavLink
                            to="/client/chatter"
                            className={`${styles.subLinks} ${pageActive.includes("/client/chatter") &&
                              styles.active
                              }  d-flex`}
                          >
                            <CustomBox children={'Chatter Clients'} />

                          </NavLink>
                        </li>
                      }
                      {
                        assignedCategory?.includes("private") &&
                        <li className="">
                          <NavLink
                            to="/client/private"
                            className={`${styles.subLinks} ${pageActive.includes("/client/private") &&
                              styles.active
                              }  d-flex`}
                          >
                            <CustomBox children={'Private Clients'} />

                          </NavLink>
                        </li>
                      }
                      <li className="">
                        <NavLink
                          to={CLASSROOM_REPORTS}
                          className={`${styles.subLinks} ${pageActive.includes(CLASSROOM_REPORTS) && styles.active
                            }  d-flex`}
                        >
                          <CustomBox children={'Classroom Plans'} />

                        </NavLink>
                      </li>
                      <li className="p-10">
                        <NavLink
                          to="/client/task-plan"
                          className={`${styles.subLinks} ${pageActive.includes("/client/task-plan") &&
                            styles.active
                            }  d-flex`}
                        >
                          <CustomBox children={'Task Plan'} />

                        </NavLink>
                      </li>

                      <li className="p-10">
                        <NavLink
                          to="/client/support-staff"
                          className={`${styles.subLinks} ${pageActive.includes("/client/support-staff") &&
                            styles.active
                            }  d-flex`}
                        >
                          <CustomBox children={'Support Staff'} />

                        </NavLink>
                      </li>

                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              }
            </li>
            {
              !onlyMdt && <li className="">
                <Accordion.Item
                  className={`${styles.accordionWrp} border-0 bg-transparent`}
                  eventKey="my_library"
                >
                  <Accordion.Header
                    className={`${styles.accordionBtn} ${pageActive.includes("my-library") && styles.active
                      } d-flex align-items-center gap-10 text-capitalize`}
                  >

                    MY LIBRARY
                  </Accordion.Header>
                  <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                    <ul className="list-unstyled  mb-0">
                      <li className="">
                        <NavLink
                          to={TASK_PLAN_TEMPLATES}
                          className={`${styles.subLinks} ${pageActive.includes(TASK_PLAN_TEMPLATES) && styles.active
                            }  d-flex`}
                        >
                          <CustomBox children="Task Plan Template" />
                        </NavLink>
                      </li>
                      <li className="">
                        <NavLink
                          to={RECOMMENDATIONS_TEMPLATES}
                          className={`${styles.subLinks} ${pageActive.includes(RECOMMENDATIONS_TEMPLATES) && styles.active
                            }  d-flex`}
                        >
                          <CustomBox children="Recommendations" />
                          {/* Component Templates */}
                        </NavLink>
                      </li>
                      <li className="">
                        <NavLink
                          to={STRATEGIES_TEMPLATES}
                          className={`${styles.subLinks} ${pageActive.includes(STRATEGIES_TEMPLATES) && styles.active
                            }  d-flex`}
                        >
                          <CustomBox children="Strategies" />
                          {/* Component Templates */}
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
            }
            {
              assignedCategory?.includes("chatter") &&
              <li className="">
                <Accordion.Item
                  className={`${styles.accordionWrp} border-0 bg-transparent`}
                  eventKey="chatter_groups"
                >
                  <Accordion.Header
                    className={`${styles.accordionBtn} ${(pageActive.includes(MANAGE_STAFF) || pageActive.includes(MANAGE_PARENT)) && styles.active
                      } fw-bold d-flex align-items-center gap-10`}
                  >

                    My Chatter Groups
                  </Accordion.Header>
                  <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                    <ul className="list-unstyled  mb-0">
                      <li>
                        <NavLink
                          to={CHATTER_EVENT}
                          className={`${styles.subLinks} ${pageActive.includes(CHATTER_EVENT) &&
                            styles.active
                            }  d-flex`}
                        >
                          <CustomBox children={'Chatter Programs'} />

                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={CHATTER_LESSON_PLANS}
                          className={`${styles.subLinks} ${pageActive.includes(CHATTER_LESSON_PLANS) &&
                            styles.active
                            }  d-flex`}
                        >
                          <CustomBox children={'Chatter Lesson Plans'} />

                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
            }
            <li className="">
              <Accordion.Item
                className={`${styles.accordionWrp} border-0 bg-transparent`}
                eventKey="workshop"
              >
                <Accordion.Header
                  className={`${styles.accordionBtn} ${(pageActive.includes(MANAGE_STAFF) || pageActive.includes(MANAGE_PARENT)) && styles.active
                    } fw-bold d-flex align-items-center gap-10`}
                >

                  My Clipboard
                </Accordion.Header>
                <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                  <ul className="list-unstyled  mb-0">
                    <li>
                      <NavLink
                        to={NOTES_TABLE}
                        className={`${styles.subLinks} ${pageActive.includes(NOTES_TABLE) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Notes'} />

                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to={WORKSHOPS}
                        className={`${styles.subLinks} ${pageActive.includes(WORKSHOPS) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Workshops'} />

                      </NavLink>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>
            {/* <li className="">
              <NavLink
                // to={POLICY_AND_PROCEDURES}
                className={`${styles.link} 
                  } d-flex align-items-center gap-10 `}
              >

                My Notifications
              </NavLink>
            </li> */}
            {/* <li className="">
              <NavLink
                to={CLASSROOM_SERVICES}
                className={`${styles.link} ${pageActive.includes(CLASSROOM_SERVICES) &&
                  styles.active
                  } d-flex align-items-center gap-10 `}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_8515_10581)">
                      <path d="M30.1987 25.363H28.3195C28.1199 23.8361 27.145 22.5501 25.8061 21.9099C26.4168 21.3697 26.8162 20.5945 26.8162 19.7136C26.8162 18.0987 25.5007 16.7832 23.8858 16.7832C22.2709 16.7832 20.9554 18.0987 20.9554 19.7136C20.9554 20.5886 21.3489 21.3697 21.9655 21.9099C21.137 22.304 20.4501 22.9438 19.9982 23.7422C19.5429 22.9464 18.857 22.3076 18.0309 21.9099C18.6416 21.3755 19.041 20.5945 19.041 19.7136C19.041 18.0987 17.7255 16.7832 16.1106 16.7832C14.4957 16.7832 13.1802 18.0987 13.1802 19.7136C13.1802 20.5886 13.5737 21.3697 14.1903 21.9099C13.3618 22.304 12.6749 22.9438 12.223 23.7422C11.7677 22.9464 11.0818 22.3076 10.2557 21.9099C10.8665 21.3697 11.2658 20.5945 11.2658 19.7136C11.2658 18.0987 9.95034 16.7832 8.3354 16.7832C6.72046 16.7832 5.40502 18.0987 5.40502 19.7136C5.40502 20.5886 5.79848 21.3697 6.41509 21.9099C5.74206 22.2311 5.15975 22.7151 4.72088 23.318C4.28202 23.9209 4.00044 24.6238 3.90166 25.363H2.01071C1.68772 25.363 1.42346 25.6272 1.42346 25.9502C1.42346 26.2732 1.68772 26.5375 2.01071 26.5375H30.1987C30.5217 26.5375 30.786 26.2732 30.786 25.9502C30.786 25.6272 30.5217 25.363 30.1987 25.363ZM22.1299 19.7195C22.1299 18.7505 22.9168 17.9636 23.8858 17.9636C24.8548 17.9636 25.6417 18.7505 25.6417 19.7195C25.6417 20.6885 24.8548 21.4754 23.8858 21.4754C22.9168 21.4754 22.1299 20.6885 22.1299 19.7195ZM14.3488 19.7195C14.3488 18.7505 15.1358 17.9636 16.1047 17.9636C17.0737 17.9636 17.8606 18.7505 17.8606 19.7195C17.8606 20.6885 17.0737 21.4754 16.1047 21.4754C15.1358 21.4754 14.3488 20.6885 14.3488 19.7195ZM6.57365 19.7195C6.57365 18.7505 7.36057 17.9636 8.32953 17.9636C9.29849 17.9636 10.0854 18.7505 10.0854 19.7195C10.0854 20.6885 9.29849 21.4754 8.32953 21.4754C7.36057 21.4754 6.57365 20.6885 6.57365 19.7195ZM5.07616 25.363C5.35217 23.8185 6.70284 22.6499 8.32366 22.6499C9.94447 22.6499 11.2951 23.8244 11.577 25.363H5.07616ZM12.8572 25.363C13.1332 23.8185 14.4839 22.6499 16.1047 22.6499C17.7255 22.6499 19.0762 23.8244 19.3522 25.363H12.8572ZM20.6324 25.363C20.9084 23.8185 22.2591 22.6499 23.8799 22.6499C25.5007 22.6499 26.8514 23.8244 27.1274 25.363H20.6324ZM30.1987 13.1129H28.3195C28.1199 11.5861 27.145 10.3 25.8061 9.6599C26.4168 9.1255 26.8162 8.34446 26.8162 7.46358C26.8162 5.84864 25.5007 4.5332 23.8858 4.5332C22.2709 4.5332 20.9554 5.84864 20.9554 7.46358C20.9554 8.33859 21.3489 9.11963 21.9655 9.6599C21.137 10.0539 20.4501 10.6937 19.9982 11.4921C19.5429 10.6964 18.857 10.0575 18.0309 9.6599C18.6416 9.1255 19.041 8.34446 19.041 7.46358C19.041 5.84864 17.7255 4.5332 16.1106 4.5332C14.4957 4.5332 13.1802 5.84864 13.1802 7.46358C13.1802 8.33859 13.5737 9.11963 14.1903 9.6599C13.3618 10.0539 12.6749 10.6937 12.223 11.4921C11.7677 10.6964 11.0818 10.0575 10.2557 9.6599C10.8665 9.1255 11.2658 8.34446 11.2658 7.46358C11.2658 5.84864 9.95034 4.5332 8.3354 4.5332C6.72046 4.5332 5.40502 5.84864 5.40502 7.46358C5.40502 8.33859 5.79848 9.11963 6.41509 9.6599C5.74206 9.98108 5.15975 10.465 4.72088 11.068C4.28202 11.6709 4.00044 12.3738 3.90166 13.1129H2.01071C1.68772 13.1129 1.42346 13.3772 1.42346 13.7002C1.42346 14.0232 1.68772 14.2874 2.01071 14.2874H30.1987C30.5217 14.2874 30.786 14.0232 30.786 13.7002C30.786 13.3772 30.5217 13.1129 30.1987 13.1129ZM22.1299 7.46946C22.1299 6.50049 22.9168 5.71358 23.8858 5.71358C24.8548 5.71358 25.6417 6.50049 25.6417 7.46946C25.6417 8.43842 24.8548 9.22534 23.8858 9.22534C22.9168 9.22534 22.1299 8.43255 22.1299 7.46946ZM14.3488 7.46946C14.3488 6.50049 15.1358 5.71358 16.1047 5.71358C17.0737 5.71358 17.8606 6.50049 17.8606 7.46946C17.8606 8.43842 17.0737 9.22534 16.1047 9.22534C15.1358 9.22534 14.3488 8.43255 14.3488 7.46946ZM6.57365 7.46946C6.57365 6.50049 7.36057 5.71358 8.32953 5.71358C9.29849 5.71358 10.0854 6.50049 10.0854 7.46946C10.0854 8.43842 9.29849 9.22534 8.32953 9.22534C7.36057 9.22534 6.57365 8.43255 6.57365 7.46946ZM5.07616 13.1129C5.35217 11.5685 6.70284 10.3998 8.32366 10.3998C9.94447 10.3998 11.2951 11.5743 11.577 13.1129H5.07616ZM12.8572 13.1129C13.1332 11.5685 14.4839 10.3998 16.1047 10.3998C17.7255 10.3998 19.0762 11.5743 19.3522 13.1129H12.8572ZM20.6324 13.1129C20.9084 11.5685 22.2591 10.3998 23.8799 10.3998C25.5007 10.3998 26.8514 11.5743 27.1274 13.1129H20.6324Z" fill="#071E3E" />
                    </g>
                    <defs>
                      <clipPath id="clip0_8515_10581">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Start Classroom Consultation
              </NavLink>
            </li> */}
            {/* <li className="">
              <NavLink
                to={CLASSROOM_REPORTS}
                className={`${styles.link} ${pageActive.includes(CLASSROOM_REPORTS) &&
                  styles.active
                  } d-flex align-items-center gap-10   `}
              >

                Start Classroom Consultation

              </NavLink>
            </li> */}
            <li className="">
              <NavLink
                to={MULTIDISCIPLINARY_SERVICES}
                className={`${styles.link} ${pageActive.includes(MULTIDISCIPLINARY_SERVICES) &&
                  styles.active
                  } d-flex align-items-center gap-10 `}
              >
                Multidisciplinary Assessment



              </NavLink>
            </li>
           {
            !onlyMdt && 
             <li className="">
              <Accordion.Item
                className={`${styles.accordionWrp} border-0 bg-transparent`}
                eventKey="access_dashboards"
              >
                <Accordion.Header
                  className={`${styles.accordionBtn} ${(pageActive.includes(MANAGE_STAFF) || pageActive.includes(MANAGE_PARENT)) && styles.active
                    } fw-bold d-flex align-items-center gap-10`}
                >

                  Access Dashboards
                </Accordion.Header>
                <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                  <ul className="list-unstyled  mb-0">
                    {/* <li>
                      <NavLink
                        to={MANAGE_STAFF}
                        className={`${styles.subLinks} ${pageActive.includes(MANAGE_STAFF) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Support Staff Dashboard'} />

                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        // to={MANAGE_PARENT}
                        className={`${styles.subLinks} ${styles.sublinkDisabled} ${pageActive.includes(MANAGE_PARENT) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Parent Dashboard'} />

                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        to={MANAGE_PARENT}
                        className={`${styles.subLinks} ${pageActive.includes(MANAGE_PARENT) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Parent Dashboard'} />

                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        // to={MANAGE_PARENT}
                        className={`${styles.subLinks} ${styles.sublinkDisabled} 
                          d-flex`}
                      >
                        <CustomBox children={'Teacher Dashboard'} />

                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink
                        to={STAFF_TASKS_TEMPLATES}
                        className={`${styles.subLinks} ${pageActive.includes(STAFF_TASKS_TEMPLATES) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Tasks Templates'} />

                      </NavLink>
                    </li> */}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>
           }
            {/*<li className="">
              <NavLink
                to={SCHOOL_DISCHARGES}
                className={`${styles.link} ${pageActive.includes(SCHOOL_DISCHARGES) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Discharges
              </NavLink>
            </li>*/}
            {/* <li className="">
              <NavLink
                to={MY_RESOURCES}
                className={`${styles.link} ${pageActive.includes(MY_RESOURCES) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                My Resources
              </NavLink>
            </li> */}
            {/* <li className="">
              <NavLink
                to={MY_FAVOURITE_GOAL}
                className={`${styles.link} ${pageActive.includes(MY_FAVOURITE_GOAL) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                My Favourite Sessions
              </NavLink>
            </li> */}
            {/* <li className="">
              <NavLink
                to={SHARED_LESSION_PLAN}
                className={`${styles.link} ${pageActive.includes(SHARED_LESSION_PLAN) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Shared Lesson Plan
              </NavLink>
            </li> */}
            {/* ROUTE OF APPOINTEMNTS IS ALSO COMMENTED */}
            {/* <li className="">
              <NavLink
                to={MANAGE_APPOINTMENT_LIST}
                className={`${styles.link} ${pageActive.includes(MANAGE_APPOINTMENT_LIST) && styles.active
                  } d-flex align-items-center gap-10 `}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-check" viewBox="0 0 16 16">
                    <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                  </svg>
                </span>
                Appointment
              </NavLink>
            </li> */}
            {/* {
              isVeteran && <li className="">
                <NavLink
                  to={MANAGE_TEAM}
                  className={`${styles.link} ${pageActive.includes(MANAGE_TEAM) && styles.active
                    } d-flex align-items-center gap-10 `}
                >

                  Manage Students
                </NavLink>
              </li>
            }
            <li className="">
              <NavLink
                to={SCHOOL_DISCHARGES}
                className={`${styles.link} ${pageActive.includes(SCHOOL_DISCHARGES) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Discharges
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to={MY_RESOURCES}
                className={`${styles.link} ${pageActive.includes(MY_RESOURCES) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                My Resources
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to={MANAGE_GROUP}
                className={`${styles.link} ${pageActive.includes(MANAGE_GROUP) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Manage Group
              </NavLink>
            </li> */}
            {/* <li className="">
              <NavLink
                to={POLICY_AND_PROCEDURES}
                className={`${styles.link} ${pageActive.includes(POLICY_AND_PROCEDURES) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Policy & Procedures
              </NavLink>
            </li> */}
          </ul>
        </div>

        <div className="py-2">
          {/* <p className="m-0 text-muted px-3" style={{ fontSize: 14 }}>
            Other Useful links
          </p> */}
          <ul className="list-unstyled ps-0 mb-0">
            <li className="">
              <NavLink
                to={ABOUT_US}
                className={`${styles.link} ${pageActive.includes(ABOUT_US) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                About us
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to={TERMS_AND_CONDITIONS}
                className={`${styles.link} ${pageActive.includes(TERMS_AND_CONDITIONS) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Terms and Conditions
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to={PRIVACY_POLICY}
                className={`${styles.link} ${pageActive.includes(PRIVACY_POLICY) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Privacy Policy
              </NavLink>
            </li>
            {/* <li className="">
              <NavLink
                to={VIDEOS}
                className={`${styles.link} ${pageActive.includes(VIDEOS) && styles.active
                  } d-flex align-items-center gap-10 `}
              >

                Videos
              </NavLink>
            </li> */}
            {
              // FOR MAYA USER ONLY
              profile?.id == 2252 &&
              <li className="">
                <Accordion.Item
                  className={`${styles.accordionWrp} border-0 bg-transparent`}
                  eventKey="deprecated"
                >
                  <Accordion.Header
                    className={`${styles.accordionBtn} ${(pageActive.includes(MANAGE_STAFF) || pageActive.includes(MANAGE_PARENT)) && styles.active
                      } fw-bold d-flex align-items-center gap-10`}
                  >

                    Deprecated Modules
                  </Accordion.Header>
                  <Accordion.Body className="pb-0 pt-0 pe-0 p-0">
                    <ul className="list-unstyled  mb-0">
                      {/* <li>
                      <NavLink
                        to={WORKSHOPS}
                        className={`${styles.subLinks} ${pageActive.includes(WORKSHOPS) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Workshops'} />

                      </NavLink>
                    </li> */}
                      {/* <li>
                      <NavLink
                        to={MANAGE_PARENT}
                        className={`${styles.subLinks} ${pageActive.includes(MANAGE_PARENT) &&
                          styles.active
                          }  d-flex`}
                      >
                        <CustomBox children={'Parent Dashboard'} />

                      </NavLink>
                    </li> */}
                      {/* <li className="">
                        <NavLink
                          to={MANAGE_PARENT}
                          className={`${styles.link} ${pageActive.includes(MANAGE_PARENT) && styles.active
                            } d-flex align-items-center gap-10 `}
                        >

                          Parent Dashboard
                        </NavLink>
                      </li> */}
                      <li className="">
                        <NavLink
                          to={MY_FAVOURITE_GOAL}
                          className={`${styles.link} ${pageActive.includes(MY_FAVOURITE_GOAL) && styles.active
                            } d-flex align-items-center gap-10 `}
                        >

                          My Favourite Sessions
                        </NavLink>
                      </li>
                      <li className="">
                        <NavLink
                          to={SHARED_LESSION_PLAN}
                          className={`${styles.link} ${pageActive.includes(SHARED_LESSION_PLAN) && styles.active
                            } d-flex align-items-center gap-10 `}
                        >

                          Shared Lesson Plan
                        </NavLink>
                      </li>
                      {
                        isVeteran && <li className="">
                          <NavLink
                            to={MANAGE_TEAM}
                            className={`${styles.link} ${pageActive.includes(MANAGE_TEAM) && styles.active
                              } d-flex align-items-center gap-10 `}
                          >

                            Manage Students
                          </NavLink>
                        </li>
                      }
                      <li className="">
                        <NavLink
                          to={MANAGE_GROUP}
                          className={`${styles.link} ${pageActive.includes(MANAGE_GROUP) && styles.active
                            } d-flex align-items-center gap-10 `}
                        >

                          Manage Group
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </li>
            }
            {/* <li className="">
              <NavLink
                className={`${styles.link} ${pageActive.includes("/login") && styles.active
                  } d-flex align-items-center gap-10 `}
                onClick={() => setShowLogoutModal(true)}
              >

                Logout
              </NavLink>
            </li> */}
          </ul>
        </div>
      </Accordion>
    </div>
  );
};

export default Sidebar;
